/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Deck_Privacy_ForbiddenInputs */



/**
* | output |
* | --- |
* | "Only organizers or the player can make a deck private" |
*
* @param {Err_Tournament_Deck_Privacy_ForbiddenInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_deck_privacy_forbidden = /** @type {((inputs?: Err_Tournament_Deck_Privacy_ForbiddenInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Deck_Privacy_ForbiddenInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Seuls les organisateurs ou le joueur peuvent rendre un deck privé")
	if (locale === "es") return /** @type {LocalizedString} */ ("Solo los organizadores o el jugador pueden hacer privado un mazo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Somente organizadores ou o jogador podem tornar um deck privado")
	if (locale === "it") return /** @type {LocalizedString} */ ("Solo gli organizzatori o il giocatore possono rendere privato un mazzo")
	return /** @type {LocalizedString} */ ("Only organizers or the player can make a deck private")
});